import React from 'react';
import ProductCategoriesTable from '@modules/product-categories/components/product-categories-table/product-categories-table.tsx';

const ProductCategories = () => {
  return (
    <div className="w-full h-full">
      <ProductCategoriesTable />
    </div>
  );
};

export default ProductCategories;
